import React from 'react'
import {
  Facebook,
  Instagram,
  Reddit,
  Twitter,
  LexisNexis,
  Weibo,
  Msn,
  Tiktok,
  VocSmall,
  YoutubeCircle,
  BlueskyCircle,
  Podcasts
  // @ts-ignore
} from '@netbasequid/core'
import { StreamSymbol, Domain } from 'enums'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { Theme } from 'features/ui/types'

export const getDataSource = (row: InsightData) => {
  switch (row.dataStreams?.[0]) {
    case 'VOC':
      return StreamSymbol.VOC
    case 'LXNX':
      return StreamSymbol.LXNX
    case 'PODCAST':
      return StreamSymbol.PODCAST
    default:
      break
  }
  return row.domain
}

export const getSourceLogo = (source: string | undefined, mode?: Theme) => {
  switch (source) {
    case Domain.FACEBOOK:
      return <Facebook mode={mode} />
    case Domain.TWITTER:
      return <Twitter mode={mode} />
    case Domain.INSTAGRAM:
      return <Instagram mode={mode} />
    case Domain.WEIBO:
      return <Weibo mode={mode} />
    case Domain.REDDIT:
      return <Reddit mode={mode} />
    case Domain.MSN:
      return <Msn mode={mode} />
    case Domain.TIKTOK:
      return <Tiktok mode={mode} />
    case Domain.YOUTUBE:
      return <YoutubeCircle mode={mode} />
    case Domain.BLUESKY:
      return <BlueskyCircle mode={mode} />
    case 'VOC':
      return <VocSmall mode={mode} />
    case 'LXNX':
      return <LexisNexis mode={mode} />
    case 'PODCAST':
      return <Podcasts mode={mode} />
    default:
      return null
  }
}
